export default __webpack_public_path__ + "static/screenshot5-0e96cd2d624b7b21a21d97b3aa63faa6.jpg";